import { useEffect } from "react";
import NavBar from "../../Components/NavBar/NavBar";
import ConsultForm from "../../Components/pageFormConsult/ConsultForm";
import SectionSpecialist from "../../Components/pageFormConsult/SectionSpecialist";
const ConsultNow = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  return (
    <>
      <NavBar sectionRefs={null} isConsultNow />
      <div className="w-full flex justify-center">
        <div className="w-full xl:w-[1225px] lg:w-full">
          <SectionSpecialist />
          <ConsultForm />
        </div>
      </div>
    </>
  );
};

export default ConsultNow;
